import { SupplierFinance } from '@linktivity/gds-neo';
import config from '../config';

const FinanceApi = new SupplierFinance.FinanceApi(config);

export default FinanceApi;
